import { useMemo } from 'react';
import { FilterType, IFilter } from '../../interfaces/Filter.interfaces';
import { useAppSelector } from '../store/useStore';

interface useCheckFilterButtonActiveProps {
  filterType: FilterType;
  filter: IFilter;
}

export const useCheckFilterButtonActive = (props: useCheckFilterButtonActiveProps) => {
  const filterStates = useAppSelector((state) => state.filter[props.filterType]);

  const isFilterButtonActive = useMemo<boolean>(() => {
    let isFilterButtonActive = false;

    filterStates.globalFilters.forEach((filter) => {
      // 파라미터로 받은 필터에 대해 활성화된 옵션이 있는지 검색
      if (props.filter?.key === filter.key) {
        if (filter.optionType === 'radio' || filter.optionType === 'checkbox') {
          filter.options.forEach((option) => {
            if (option.isSelected && !option.isDefault) {
              isFilterButtonActive = true;
            }
          });
        } else if (filter.optionType === 'slider') {
          filter.options.forEach((option) => {
            if (option.value !== option.defaultValue) {
              isFilterButtonActive = true;
            }
          });
        }
      }

      if (
        props.filterType === 'directDealFilter' &&
        props.filter.key === 'engineOutputInPs' &&
        filter.key === 'engineOutputInPs'
      ) {
        const isRowConfigActive = filterStates.globalFilters
          .find((filter) => filter.key === 'rowConfig')
          ?.options.some((option) => option.isSelected);
        if (isRowConfigActive) {
          isFilterButtonActive = true;
        }
      }
    });

    return isFilterButtonActive;
  }, [filterStates, props.filter, props.filterType]);

  return { isFilterButtonActive };
};
